
import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import Delhi from "../../../src/assests/images/delhi.svg";
import Mumbai from "../../../src/assests/images/mumbai.svg";

import { useParams } from "react-router-dom";
import { getToken } from "../../utils/utils";
interface Props {
  outletsdata: {
    city: string;
    contact_count: number;
  }[];
  outletlength: string;
}

const OutletsCard = ({ outletsdata, outletlength }: Props) => {
  const [outletData, setOutletData] = useState<{ city: string; count: number }[]>(
    []
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
const { id } = useParams();
const token = getToken();
const todayDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format

// useEffect(() => {
//   const fetchOutlets = async () => {
//     try {
//       const reqBody = {
//         task_id: String(id),
//         location: String,
//         day: todayDate,
//       };

//       const response = await dashboard(reqBody, token);
//       if (response.data && response.data.task_summary?.totaloutlets) {
//         setOutletData(response.data.task_summary.totaloutlets);
//       } else {
//         throw new Error("Invalid response format");
//       }
//     } catch (error: any) {
//       setError(error.message || "Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchOutlets();
// }, [id, token]); 

// if (loading) return <Typography>Loading...</Typography>;
// if (error) return <Typography color="error">{error}</Typography>
return (
  <Box
      sx={{
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        padding: "16px",
        backgroundColor: "#fff",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        marginTop: "30px",
      }}
    >
      <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "18px" }}>
        {outletlength?outletlength:0} Outlets
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        mb={2}
        sx={{ color: "#7D7E7F", marginTop: "5px" }}
      >
        Total Outlets
      </Typography>
      <Grid container spacing={4}>
      {outletsdata.map((item, index) => (
        <>
          {item.city.toLowerCase().includes("delhi") ||
          item.city.toLowerCase().includes("delhi ncr") ? (
            <Grid item xs={6} key={`delhi-${index}`}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Box sx={{ marginLeft: "30px" }}>
                  <img
                    src={Delhi}
                    alt="Delhi Icon"
                    style={{ marginBottom: "8px" }}
                  />
                </Box>
                <Box sx={{ marginLeft: "20px" }}>
                  <Typography variant="h4" fontWeight="bold">
                    {item.contact_count}
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    {item.city}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ) : null}

          {item.city.toLowerCase().includes("mumbai") && (
            <Grid item xs={6} key={`mumbai-${index}`}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Box>
                  <img
                    src={Mumbai}
                    alt="Mumbai Icon"
                    style={{ marginBottom: "8px" }}
                  />
                </Box>
                <Box sx={{ marginLeft: "20px" }}>
                  <Typography variant="h4" fontWeight="bold">
                    {item.contact_count}
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    {item.city}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          )}
        </>
      ))}
    </Grid>
  </Box>
);

}
export default OutletsCard;
